import { SxProps } from "@mui/material";
import Colors from "../../theme/Colours";

export const buttonStyle: SxProps = {
  borderRadius: { xs: "5px", sm: "60px" },
  alignSelf: { xs: "center", sm: "flex-end" },
  height: { xs: "30px", sm: "48px" },
  width: { xs: "238px", sm: "248px" },
  mb: { xs: "30px", sm: "0px" },
  padding: { xs: "18px 32px", sm: "10px 24px" },
  fontSize: { xs: "10px", sm: "18px" },
};

export const makePaymentButtonStyle: SxProps = {
  ...buttonStyle,
  alignSelf: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white",
  mb: 0,
  fontFamily: "Poppins",
  width: { xs: "150px", sm: "248px" },
  padding: { xs: "2px", sm: "10px 24px" },
};

export const mainContainerStyle = {
  display: "flex",
  flexDirection: "column",
};

export const buttonContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  marginRight: "16px",
  gap: "16px",
};

export const cardContainerStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: { xs: "10px 7px 10px 16px", sm: "24px 16px" },
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
  backgroundColor: Colors.background2,
  borderRadius: { xs: 0, sm: "8px" },
  marginBottom: "25px",
  gap: { xs: "9px", sm: "75px" },
};

export const cardMediaStyle: SxProps = {
  width: { xs: "26px", sm: "67px" },
  height: { xs: "26px", sm: "67px" },
  borderRadius: "8px",
  flexShrink: 0,
};

export const textContainerStyle: SxProps = {
  flexGrow: 1,
  "& .MuiTypography-root": {
    fontSize: { xs: "10px", sm: "18px", md: "24px" },
    fontWeight: 500,
  },
};

export const cancelButtonStyle = {
  color: Colors.redText,
  border: `1px solid ${Colors.redText}`,
  width: "300px",
  fontSize: "13.52px",
};

export const saveButtonStyle1 = {
  width: "300px",
};

export const createInvoiceButtonStyle = {
  width: "196px",
  borderRadius: "8px",
  border: `1px solid ${Colors.black}`,
  color: Colors.createInvoiceButton,
};

export const saveButtonStyle = {
  width: "196px",
  marginTop: "37px",
  fontSize: "13.52px",
};

// CustomerOrderLeft styles
export const customerOrderCardStyle: SxProps = {
  p: { xs: 2, sm: 3 },
  borderRadius: 1,
};

export const headerRowStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "4px",
};

export const addressTypographyStyle: SxProps = {
  fontWeight: 500,
  mb: 0.5,
};

export const addressDetailStyle: SxProps = {
  maxWidth: 520,
};

export const orderIdBoxStyle: SxProps = {
  bgcolor: Colors.trackingbox,
  border: `1px solid ${Colors.greyBorder}`,
  borderRadius: 1.5,
  px: 1.5,
  py: 1,
  minWidth: 180,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const orderIdLabelStyle: SxProps = {
  color: Colors.black,
  fontWeight: 500,
};

export const orderIdValueStyle: SxProps = {
  fontWeight: 400,
  color: Colors.mutedText,
};

export const copyButtonStyle: SxProps = {
  color: Colors.primaryButtonOrange,
};

export const cardContentStyle: SxProps = {
  px: 0,
};

export const stepperStyle: SxProps = {
  mt: 2.5,
  "& .MuiStepConnector-line": { borderWidth: { xs: 5, sm: 8 } },
  "& .MuiStepConnector-root": { top: { xs: 10, sm: 20 } },
};

export const stepLabelTypographyStyle = (
  isActive: boolean,
  isCurrent: boolean
): SxProps => ({
  color: isActive ? Colors.primaryButtonOrange : Colors.greyTypography,
  fontWeight: isCurrent ? 600 : 500,
});

export const downloadButtonContainerStyle: SxProps = {
  mt: 2,
  mb: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
};

export const helpBoxStyle: SxProps = {
  mt: 2,
  p: 2,
  borderRadius: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  bgcolor: Colors.trackingHelpBoxBG,
};

export const helpBoxTitleStyle: SxProps = {
  fontWeight: 600,
};

export const helpBoxSubtitleStyle: SxProps = {
  color: Colors.greyTypography,
};

export const helpPhoneBoxStyle: SxProps = {
  bgcolor: "white",
  borderRadius: 1,
  px: 2,
  py: 1,
  fontWeight: 600,
  fontSize: 14,
};

export const invoiceInfoCardStyle: SxProps = {
  mt: 2,
  p: 2,
  borderRadius: 1,
  display: "flex",
  alignItems: "center",
  gap: 1,
  bgcolor: Colors.trackingHelpBoxBG,
};

export const invoiceInfoIconStyle: SxProps = {
  width: 20,
  height: 20,
  flexShrink: 0,
};

export const invoiceInfoTextStyle: SxProps = {
  fontSize: "13px",
  color: Colors.textDarkergrey,
};

// OrderSummaryRight styles
export const rightCardStyle: SxProps = {
  width: "100%",
  borderRadius: "4px",
};

export const rightCardContentStyle: SxProps = {
  p: 2,
};

export const sectionTitleStyle: SxProps = {
  fontWeight: 600,
  mb: 1,
};

export const dividerStyle: SxProps = {
  my: 2,
};

export const notesBoxStyle: SxProps = {
  bgcolor: Colors.trackingbox,
  border: `1px solid ${Colors.trackingBoxBorder}`,
  borderRadius: 1.5,
  px: 1.5,
  py: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const notesTextStyle: SxProps = {
  mb: 2,
};

export const orderSummaryRowStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  py: 1,
  borderBottom: `1px solid ${Colors.greyBorder}`,
};

export const orderSummaryTotalStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  mt: 2,
};

export const totalLabelStyle: SxProps = {
  fontWeight: 500,
};

export const totalValueStyle: SxProps = {
  fontWeight: 600,
};

export const cancelOrderButtonContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "flex-end",
  mt: 2,
};

export const breakdownRowStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  py: 0.5,
  fontSize: "13px",
};

export const breakdownTotalStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  py: 0.5,
  fontWeight: 600,
  fontSize: "13px",
};

// OrderTracking styles
export const orderTrackingMainContainerStyle: SxProps = {
  ...mainContainerStyle,
  display: { xs: "block", md: "grid" },
  gridTemplateColumns: { md: "minmax(0,1fr) 380px" },
  gap: { xs: 1, md: 1 },
  alignItems: "start",
};

export const orderNotFoundContainerStyle: SxProps = {
  ...mainContainerStyle,
  textAlign: "center",
};
